export default {
  beforeYouContinue: 'Before you continue, please let us know you\'re human.',
  error: 'Something went wrong. Please try again.',
  submit: 'Submit',
}
